<div class="main-wrapper" [ngClass]="{'canvas-open': canvasControlsExpanded }">
	<context-message></context-message>
	<router-outlet>
		<div id="loading">
			<span class="fa fa-circle-o-notch fa-spin fa-fw"></span>
		</div>
	</router-outlet>
</div>